import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebaseConfig"; // Import Firebase auth
import bg1 from "../assets/img/bg1.jpg";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setLoading(true);

    try {
      // Send password reset email
      await sendPasswordResetEmail(auth, email);
      setMessage("A password reset link has been sent to your email.");
    } catch (error) {
      console.error("Error sending password reset email:", error.message);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5">Ezarly</Link>
              <Card.Title>Forgot Password</Card.Title>
              <Card.Text>Enter your email address to reset your password.</Card.Text>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handlePasswordReset}>
                <div className="mb-4">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {message && <div className="mb-3 text-success">{message}</div>}
                {error && <div className="mb-3 text-danger">{error}</div>}
                <Button
                  type="submit"
                  className="btn-sign"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </Button>
              </Form>
            </Card.Body>
            <Card.Footer>
              Remember your password? <Link to="/pages/signin2">Sign In</Link>
            </Card.Footer>
          </Card>
        </Col>
        <Col className="d-none d-lg-block">
          <img src={bg1} className="auth-img" alt="Background" />
        </Col>
      </Row>
    </div>
  );
}
